<template>
  <div
    id="article"
    class="h-screen w-screen bg-white overflow-y-scroll smooth-scroll"
  >
    <div class="mx-auto pt-6 pb-10">
<div  class="mb-1 px-4 flex flex-wrap justify-start mx-auto container">
  <a href="/blog" class="mx-4 border-2 border-gray-500 text-2xl uppercase  hover:bg-gray-900 hover:text-gray-100 text-gray-800 font-bold px-4 shadow-sm rounded-lg inline-flex items-center">
  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-8 w-8"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg> 
  <span class="mr-2">Back</span></a> 
  <div class="flex flex-grow justify-end mx-4">
    <a href="/" class="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-125 duration-300 rounded-xl border-2 border-yellow-900 shadow-sm text-2xl uppercase bg-black hover:bg-gray-900 text-gray-800 font-bold py-2 px-4 rounded-lg inline-flex items-center" style="color: rgb(255, 204, 0);">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-8 w-8 m-1"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg> 
    <span class="mr-2">Big Timer</span></a></div></div>
  <br/>
  <hr/>

      <div
        class="leading-relaxed flex flex-wrap justify-center items-center mt-20 underline underline-offset-8 decoration-gray-300 text-gray-800 text-center text-4xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-bold"
      >
        {{ posts.title }}
      </div>
      <div
        id="article-data"
        class="flex flex-wrap text-start text-gray-800 mt-20 mx-auto w-3/4 sm:w-2/3 md:w-1/2 lg:w-1/2 xl:w-1/2 container"
      ></div>
    </div>
  </div>
</template>

<script>
import { article } from "@/components/articles/data.js";

// export default {
//   title: 'Blog | Big Timer | Fullscreen countdown timer'
// }

export default {
  name: "ArticleDetail",

  mounted() {
    const excerptData = article.list.filter(
      a => a.slug === this.$route.params.slug
    );
    const postExcerpt = Object.assign({}, ...excerptData);
    document.getElementById("article-data").innerHTML = postExcerpt.excerpt;
  },
  data() {
    const articleData = article.list.filter(
      a => a.slug === this.$route.params.slug
    );
    const posts = Object.assign({}, ...articleData);
    document.title = `${posts.title} | Big Timer | Fullscreen countdown timer`;
    return {
      posts
    };
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0%;
  color: ;
}
h1 {
  /* font-size: initial;
  font-weight: unset; */
}

.sub-heading {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue